import {
  isMediaCardString,
  keyToMediaCardType,
  type MediaCardType,
} from '@wandb/weave/common/types/media';

import {type Data} from '../../../state/runs/types';

/** The card type of the first logged value for `mediaKey`, read from fetched run histories. */
export function getMediaCardTypeFromHistories(
  histories: Data['histories']['data'],
  mediaKey: string | undefined
): MediaCardType | undefined {
  if (mediaKey == null) {
    return undefined;
  }
  for (const {history} of histories) {
    const mediaString = history.find(row => mediaKey in row)?.[mediaKey]?._type;
    if (typeof mediaString === 'string' && isMediaCardString(mediaString)) {
      return keyToMediaCardType(mediaString);
    }
  }
  return undefined;
}
